var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconZone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#09101A",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 4C5 4.55228 4.55228 5 4 5C3.44772 5 3 4.55228 3 4C3 3.44772 3.44772 3 4 3C4.55228 3 5 3.44772 5 4ZM4.5 5.93699C5.27592 5.73728 5.86961 5.08365 5.9811 4.27605L14.0203 6.28584C14.1352 7.08893 14.7272 7.73809 15.5 7.93699V14.063C14.7972 14.2439 14.2439 14.7972 14.063 15.5H5.93699C5.7561 14.7972 5.2028 14.2439 4.5 14.063L4.5 5.93699ZM16.5 14.063C17.3626 14.285 18 15.0681 18 16C18 17.1046 17.1046 18 16 18C15.0681 18 14.285 17.3626 14.063 16.5H5.93699C5.71497 17.3626 4.93192 18 4 18C2.89543 18 2 17.1046 2 16C2 15.0681 2.63739 14.285 3.5 14.063L3.5 5.93699C2.63739 5.71497 2 4.93192 2 4C2 2.89543 2.89543 2 4 2C4.82377 2 5.53121 2.49803 5.83767 3.20942L14.1323 5.28308C14.4206 4.53265 15.1481 4 16 4C17.1046 4 18 4.89543 18 6C18 6.93192 17.3626 7.71497 16.5 7.93699V14.063ZM16 15C15.4477 15 15 15.4477 15 16C15 16.5523 15.4477 17 16 17C16.5523 17 17 16.5523 17 16C17 15.4477 16.5523 15 16 15ZM16 7C16.5523 7 17 6.55228 17 6C17 5.44772 16.5523 5 16 5C15.4477 5 15 5.44772 15 6C15 6.55228 15.4477 7 16 7ZM5 16C5 15.4477 4.55228 15 4 15C3.44772 15 3 15.4477 3 16C3 16.5523 3.44772 17 4 17C4.55228 17 5 16.5523 5 16Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconZone);
export default __webpack_public_path__ + "static/media/icon-zone.45a203d82996ac4a53a249a408b0b557.svg";
export { ForwardRef as ReactComponent };